<template>
  <el-tree class="tree-w-stroke obj-tree" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current @node-click="clickNode" :filter-node-method="filterNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span v-if="node.isLeaf">
        <span>{{data.label}}</span>
      </span>
      <!-- root, group -->
      <span v-else>
        <span class="group">{{data.label}}</span>
      </span>
    </span>
  </el-tree>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import LogAPI from '@/api/log/integrated-log';
import RouterTree from '@/mixins/router/tree';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps, treeType } from '@/constants/tree';

export default {
  name: 'WSimpleSearchTree',
  mixins: [RouterTree, TreeFilter],
  props: {
    treeTypes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      treeRef: 'indexTree',
      treeType: treeType.LOG_INDEX,
      treeTypesInMenu: this.treeTypes,
      defaultProps,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    isNil,
    isEmpty,
    loadData() {
      LogAPI.getLogIndexTree().then((response) => {
        if (response.data.success) {
          this.treeData = [response.data.data];
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 트리', false));
        throw new Error(e);
      });
    },
    clickNode(node) {
      // 노드 클릭 시 이벤트
      this.treeNode = node;
      this.routeByTreeKey(this.concatTreeTypeAndTreeKey(node[this.defaultProps.treeKey]));
    },
  },
};
</script>

<style module>
.tree {
  height: calc(100% - 55px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/LogIndexTree.vue